<template lang="pug">
  div
    delivery-state-cards.mb-4
    partner-error-alert(:count="partnerErrorCount" @filter-errors="handleFilterErrors")
    .tabla.sombra
      b-form.mb-2(@submit.stop.prevent="fetchData")
        b-form-row
          b-col.mb-2(cols="12")
            h3 Envíos
          b-col.mb-2(cols="12" md="2")
            b-form-input(v-model="filterOptions.search" placeholder="buscar")
          b-col.mb-2(cols="12" md="auto")
            b-input-group()
              b-form-datepicker(
                label-no-date-selected="Desde"
                v-model="filterOptions.from"
                :date-format-options="{ 'year': 'numeric', 'month': 'numeric', 'day': 'numeric' }"
                reset-button
                today-button
                label-today-button="Hoy"
            )
          b-col.mb-2(cols="12" md="auto")
            b-input-group()
              b-form-datepicker(
                label-no-date-selected="Hasta"
                v-model="filterOptions.to"
                :date-format-options="{ 'year': 'numeric', 'month': 'numeric', 'day': 'numeric' }"
                reset-button
                today-button
                label-today-button="Hoy"
            )
          b-col.mb-2(cols="12" md="auto")
            v-select(v-model="filterOptions.storeId" :options="storeOptions" :reduce="store => store.value" style="min-height: 40px")
          b-col.mb-2(cols="12" md="auto")
            v-select(v-model="filterOptions.driverId" :options="driverOptions" :reduce="driver => driver.value" style="min-height: 40px")
          b-col.mb-2(cols="12" md="auto")
            b-form-select(v-model="filterOptions.state" :options="stateOpations")
          b-col.mb-2(cols="12" md="auto")
            b-form-select(v-model="filterOptions.pickedUpAtStore")
              b-form-select-option(:value="null") Recepción
              b-form-select-option(:value="true") Recepcionados
              b-form-select-option(:value="false") No recepcionados
          b-col.mb-2(cols="12" md="auto")
            b-form-select(v-model="filterOptions.partnerCode" :options="partnerOptions" :reduce="partner => partner.value" style="min-height: 40px")
          b-col.mb-2(cols="12" md="auto")
            b-button(type="submit" block) Filtrar
          b-col.mb-2(cols="12" md="auto")
            b-button(v-b-modal.upload-deliveries-modal block) Importar Envíos
          //- b-col.mb-2(cols="12" md="auto")
          //-   b-button(href="PlantillaCargaMasiva.xlsx") Descargar Plantilla
          b-col.mb-2(cols="12" md="auto")
            b-button(v-b-modal.create-delivery-form-modal block) Ingresar Nuevo
          b-col.mb-2(cols="12" md="auto")
            b-button(@click="downloadExcelDelivery({ params: { ...filters } }), fetchData()" block) Exportar Excel
          b-col.mb-2(cols="12" md="auto")
            b-dropdown(text="Acciones")
              b-dropdown-item-button(v-b-modal.deliveries-change-driver-form-modal) Cambiar Conductor
              b-dropdown-item-button(@click="deleteDeliveries") Eliminar Envíos
              b-dropdown-item-button(@click="hideDeliveries") Ocultar Envíos
              b-dropdown-item-button(@click="noHideDeliveries") Desocultar Envíos
              b-dropdown-item-button(v-b-modal.deliveries-change-date-form-modal) Cambiar Fechas
              b-dropdown-item-button(@click="printSelectedPackages()") Imprimir Seleccionados
              b-dropdown-item-button(v-if="user.role==='admin'" v-b-modal.deliveries-massive-change-driver-modal) Asignar Conductor Masivo
              b-dropdown-item-button(@click="bulkPrintByDate()") Impresión Masiva Por Fecha
              b-dropdown-item-button(@click="handleDriverReport()") Generar Reporte Conductores
              b-dropdown-item-button(v-b-modal.deliveries-massive-set-partner-modal) Externalizar Envíos
              b-dropdown-item-button(@click="$refs.changeDeliveryStateMasiveModal.show(selectedIds)") Cambiar Estado Masivo
              b-dropdown-item-button(@click="openBulkAssignPartner") Asignar Partner
              b-dropdown-item-button(v-if="$debug.enabled" @click="$refs.deliveriesSyncPartnerStatusModal.show(selectedIds)") Sincronizar Estado Partner
              b-dropdown-item-button(v-if="$debug.enabled" @click="$refs.bulkExecuteWebhookChangeStateModal.show(selectedIds)") Ejecutar Webhook Cambio Estado
      b-table(
        :fields="fields" :items="deliveryData"
        responsive :busy="isBusy"
      )
        template(#table-busy)
          .text-center.text-muted.my-2
            b-spinner.align-middle.mr-2(small)
            strong Cargando...
        template(#head(select))
          b-form-checkbox(v-model="selectedAllIds" @change="toggleSelectAll")
        template(#cell(select)="{item}")
          b-form-checkbox(:value="item.id" v-model="selectedIds" @change="handlePackageToPrint(item.actions)")
        template(#cell(state)="{value}")
          div
            b-badge(v-if="value === 'Entregado'" variant="success") {{ value }}
            b-badge(v-else-if="value === 'Rechazado'" variant="danger") {{ value }}
            b-badge(v-else-if="value === 'Cancelado'" variant="cancelado") {{ value }}
            b-badge(v-else-if="value === 'Pendiente'" variant="warning").text-white {{ value }}
            b-badge(v-else variant="light") {{ value }}
        template(#cell(pickup)="{value, item}")
          div.pickup-cell
            span(:id="pickupBadgeId(item)")
              b-badge.pickup-badge(
                v-if="value === true"
                :class="canChangeScan ? 'pickup-badge--clickable' : ''"
                variant="success"
                @click="canChangeScan && openConfirmScanModal(item)"
              ) Recepcionado
              b-badge.pickup-badge(
                v-else
                :class="canChangeScan ? 'pickup-badge--clickable' : ''"
                variant="danger"
                @click="canChangeScan && openConfirmScanModal(item)"
              ) No recepcionado
            b-tooltip(
              v-if="value === true && hasPickupScanInfo(item)"
              :target="pickupBadgeId(item)"
              triggers="hover"
              placement="top"
            )
              .pickup-tooltip
                .pickup-tooltip__row
                  span.pickup-tooltip__label Fecha:
                  span.pickup-tooltip__value {{ formatPickupDate(item.pickedUpAtStoreAt) }}
                .pickup-tooltip__row
                  span.pickup-tooltip__label Usuario:
                  span.pickup-tooltip__value {{ formatPickupUser(item) }}
                .pickup-tooltip__row
                  span.pickup-tooltip__label Modo:
                  span.pickup-tooltip__value {{ formatPickupMode(item.pickedUpAtStoreMode) }}
        template(#cell(lastSendSMS)="{value, item}")
          div(style="display: flex; align-items: center; justify-content: center; min-width: 180px;")
            | {{ value ? $moment(value).format('DD-MM-YYYY HH:mm') : 'Sin enviar' }}
            | &nbsp;
            .material-icons(
              v-if="value"
              :style="item.lastSendSMSErrorMessage ? 'color: #f46a6a' : 'color: #00c5ac'"
              v-b-tooltip.hover :title="item.lastSendSMSErrorMessage || 'Enviado Correctamente'"
            ) {{ item.lastSendSMSErrorMessage ? 'error' : 'check' }}
        template(#cell(actions)="{value}")
          .botones-accion
            b-button.mr-2.mb-1.boton-editar(@click="openEditModal(value)")
              .material-icons create
            b-button.mr-2.mb-1.boton-editar-avanzado(v-if="$debug.enabled" @click="openAdvancedEditModal(value)" v-b-tooltip.hover title="Edición avanzada")
              .material-icons tune
            b-button.mr-2.mb-1.boton-ver(@click="$router.push(`/envio/${value.id}`)")
              .material-icons remove_red_eye
            //- b-button.mb-1.boton-imprimir(@click="printSelectedPackages()")
            b-button.mb-1.boton-imprimir(@click="printPackageLabel(value)")
              .material-icons print
            b-button.mb-1.boton-eliminar(@click="onDeleteDelivery(value)")
              .material-icons delete_outline
            b-tooltip(:target="`sync-error-${value.id}`" triggers="hover") Error al sincronizar con partner
            span(v-if="value.partnerDeliverySyncError && user.role === 'admin'" :id="`sync-error-${value.id}`" style="cursor: pointer; color: rgb(241, 180, 76)")
              .material-icons error_outline
        template(v-slot:cell(storeName)="{item}")
          .columna {{item.storeName}}
      b-pagination-nav(
        align="center"
        :number-of-pages="totalPages? totalPages : 1"
        :link-gen="linkGen"
        v-model="currentPage"
        )
    b-modal#create-delivery-form-modal(ref="createDeliveryFormModal" hide-footer title="Creando Envío")
      delivery-form(@done="onDoneDeliveryModal")

    b-modal(ref="updateDeliveryFormModal" hide-footer :title="`Editando Envío #${selectedDelivery ? selectedDelivery.id: ''}`")
      delivery-form(v-if="selectedDelivery" @done="onDoneDeliveryModal" :delivery="selectedDelivery" :editMode="true")
    b-modal(ref="advancedEditDeliveryFormModal" hide-footer size="lg" :title="`Edición Avanzada - Envío #${selectedDelivery ? selectedDelivery.id: ''}`")
      delivery-advanced-edit-form(v-if="selectedDelivery" @done="onDoneAdvancedEditModal" @cancel="$refs.advancedEditDeliveryFormModal.hide()" :delivery="selectedDelivery")
    b-modal#upload-deliveries-modal(title="Importar Envíos" ok-only @hide="isExcelErrors = true")
      upload-deliveries-from-exel(ref="uploadDeliveryFromExcelForm" @errors="checkExcelErrors" @showSaveBtn="toggleSaveBtn" @done="showSaveBtn = false")
      template(#modal-footer="{close}")
        b-button(v-if="showSaveBtn" @click="$refs.uploadDeliveryFromExcelForm.onSubmit()") Guardar envíos
        b-button(@click="close()" variant="outline-primary") {{ showSaveBtn ? 'Cancelar' : 'Cerrar' }}
    b-modal#deliveries-change-driver-form-modal(ref='deliveriesChangeDriverFormModal' title="Asignar envíos" hide-footer @hide="fetchData" no-close-on-backdrop no-close-on-esc)
      deliveries-change-driver-form(@done="$refs.deliveriesChangeDriverFormModal.hide()" :ids="selectedIds")
    b-modal#deliveries-change-date-form-modal(ref="updateDeliveriesDatesModal" title="Importar Envíos" hide-footer @hide="fetchData")
      DeliveryChangeDateForm(@done="$refs.updateDeliveriesDatesModal.hide()" :ids="selectedIds")
    b-modal#deliveries-massive-change-driver-modal(ref='deliveriesMassiveChangeDriverModal' title="Asignar Conductor Masivo" ok-only=true ok-title="Cancelar" @hide="fetchData, deliveriesEmpty = true")
      deliveries-massive-change-driver(ref="deliveriesMassiveChangeDriverForm" @done="$refs.deliveriesMassiveChangeDriverModal.hide()" @checkDeliveries="checkDeliveries" :ids="selectedIds")
      template(#modal-footer="{close}")
        b-button(@click="$refs.deliveriesMassiveChangeDriverForm.onSubmit()" :disabled="deliveriesEmpty") Enviar
        b-button(@click="close()" variant="outline-primary") Cancelar

    PrintAllPackagesLabel(ref="allPackagesLabelTemplate")
    DeliveriesMassiveSetPartner
    ChangeDeliveryStateMasiveModal(ref="changeDeliveryStateMasiveModal" @done="fetchData")
    DeliveriesSyncPartnerStatusModal(v-if="$debug.enabled" ref="deliveriesSyncPartnerStatusModal" @done="fetchData")
    DeliveriesBulkAssignPartnerModal(ref="deliveriesBulkAssignPartnerModal" @done="fetchData")
    BulkExecuteWebhookChangeStateModal(ref="bulkExecuteWebhookChangeStateModal" @executed="fetchData")
    ConfirmChangeScanStatusModal(
      v-model="showConfirmScanModal"
      :delivery="selectedDeliveryForScan"
      @confirmed="onConfirmScanChange"
    )
    PrintShippingLabels(ref="shippingLabels")
</template>
<script>
import DeliveryForm from './DeliveryForm'
import { mapActions, mapGetters } from 'vuex'
import partnerUtils from '../../utils/partnerUtils'
import MakeToastMixin from '../mixins/MakeToastMixin'
import UploadDeliveriesFromExel from './UploadDeliveriesFromExel'
import DeliveriesChangeDriverForm from './DeliveriesChangeDriverForm'
import BulkDeleteDeliveryMixin from './mixins/BulkDeleteDeliveryMixin'
import BulkUpdateDeliveryMixin from './mixins/BulkUpdateDeliveryMixin'
import DeliveryStateCards from './DeliveryStateCards'
import DeliveryChangeDateForm from './DeliveryChangeDateForm'
import PrintAllPackagesLabel from './printPackages/PrintAllPackagesLabel.vue'
import DeliveriesMassiveChangeDriver from './DeliveriesMassiveChangeDriver.vue'
import DeliveriesMassiveSetPartner from './DeliveriesMassiveSetPartner.vue'
import ChangeDeliveryStateMasiveModal from './ChangeDeliveryStateMasiveModal.vue'
import PartnerErrorAlert from './PartnerErrorAlert.vue'
import DeliveriesSyncPartnerStatusModal from './DeliveriesSyncPartnerStatusModal.vue'
import DeliveriesBulkAssignPartnerModal from './DeliveriesBulkAssignPartnerModal.vue'
import BulkExecuteWebhookChangeStateModal from './BulkExecuteWebhookChangeStateModal.vue'
import DeliveryAdvancedEditForm from './DeliveryAdvancedEditForm.vue'
import ConfirmChangeScanStatusModal from './ConfirmChangeScanStatusModal.vue'
import PrintShippingLabels from './printPackages/PrintShippingLabels.vue'

export default {
  mixins: [MakeToastMixin, BulkDeleteDeliveryMixin, BulkUpdateDeliveryMixin],
  props: {
    deliveryList: Array
  },
  components: {
    DeliveryForm,
    UploadDeliveriesFromExel,
    DeliveriesChangeDriverForm,
    DeliveryStateCards,
    DeliveryChangeDateForm,
    PrintAllPackagesLabel,
    DeliveriesMassiveChangeDriver,
    DeliveriesMassiveSetPartner,
    ChangeDeliveryStateMasiveModal,
    PartnerErrorAlert,
    DeliveriesSyncPartnerStatusModal,
    DeliveriesBulkAssignPartnerModal,
    BulkExecuteWebhookChangeStateModal,
    DeliveryAdvancedEditForm,
    ConfirmChangeScanStatusModal,
    PrintShippingLabels
  },
  data() {
    return {
      lastIdRequestDeliveries: null,
      currentPage: 1,
      selectedDelivery: null,
      ancho: 0,
      totalPages: null,
      selectedIds: [],
      packages: [],
      isBusy: false,
      selectedPackages: [],
      selectedAllIds: false,
      isExcelErrors: true,
      deliveriesEmpty: true,
      showSaveBtn: false,
      fetchDebounce: null,
      partnerOptions: [
        { text: 'Seleccionar Partner', value: null },
        ...partnerUtils.partnerSelectOptions,
        { text: 'Sin Partner', value: 'NULL' }
      ],
      stateOpations: [
        { text: 'Estado', value: null },
        { value: 'NULL', text: 'Por entregar' },
        { value: 'entregado', text: 'Entregado' },
        { value: 'pendiente', text: 'Pendiente' },
        { value: 'rechazado', text: 'Rechazado' },
        { value: 'cancelado', text: 'Cancelado' }
      ],
      filterOptions: {
        from: null,
        to: null,
        state: null,
        storeId: null,
        driverId: null,
        partnerCode: null,
        search: '',
        page: 0,
        size: 30,
        withPartnerSyncError: null,
        pickedUpAtStore: null
      },
      showConfirmScanModal: false,
      selectedDeliveryForScan: null,
      scanChangeDebounce: false,
      fields: [
        { key: 'select' },
        { label: 'Id', key: 'id' },
        { label: 'Nombre Tienda', key: 'storeName' },
        { label: 'Cliente', key: 'customerName' },
        { label: 'Conductor', key: 'driverName' },
        { label: 'Dirección', key: 'address' },
        { label: 'Comuna', key: 'commune' },
        { label: 'Fecha', key: 'date' },
        { label: 'Teléfono Cliente', key: 'customerPhone' },
        { label: 'Estado', key: 'state' },
        { label: 'Recepcionado', key: 'pickup' },
        { label: 'Partner', key: 'partnerCode' },
        { label: 'Acciones', key: 'actions' }
      ]
    }
  },
  methods: {
    ...mapActions(['listDelivery', 'deleteDelivery', 'listUser', 'listStore', 'getCountStates', 'downloadExcelDelivery', 'getDriverReport', 'countPartnerErrorDeliveries', 'scanDelivery', 'getLabelsByIds']),
    handleDriverReport() {
      if (!this.filterOptions.from || !this.filterOptions.to) {
        this.$bvToast.toast('Debe seleccionar un rango de fechas para generar el reporte', { variant: 'warning', title: 'Error' })
        return
      }
      const params = {
        from: this.filterOptions.from,
        to: this.filterOptions.to
      }
      this.getDriverReport({ params })
    },
    toggleSelectAll(value) {
      if (value) {
        this.selectedIds = this.allDeliveryIds
        this.selectedPackages = [...this.deliveries]
      } else {
        this.selectedIds = []
        this.selectedPackages = []
      }
    },
    toggleSaveBtn(value) {
      this.showSaveBtn = value
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    },
    openBulkAssignPartner() {
      if (!this.selectedIds.length) {
        this.$bvToast.toast('Debe seleccionar al menos un envío', {
          title: 'Aviso',
          variant: 'warning'
        })
        return
      }
      this.$refs.deliveriesBulkAssignPartnerModal.show(this.selectedIds)
    },
    async deleteDeliveries() {
      const response = await this.onBulkDeleteDeliveryMixin({ deliveriesIds: this.selectedIds })
      if (response && response.ok) {
        this.fetchData()
        this.toggleSelectAll(false)
      }
    },
    async hideDeliveries() {
      const response = await this.onBulkUpdateDeliveryMixin({ deliveriesIds: this.selectedIds, hide: true })
      if (response && response.ok) {
        this.fetchData()
        this.toggleSelectAll(false)
      }
    },
    checkExcelErrors(value) {
      this.isExcelErrors = value
    },
    async noHideDeliveries() {
      const response = await this.onBulkUpdateDeliveryMixin({ deliveriesIds: this.selectedIds, hide: false })
      if (response && response.ok) {
        this.fetchData()
        this.toggleSelectAll(false)
      }
    },
    checkDeliveries(value) {
      this.deliveriesEmpty = value
    },
    handlePackageToPrint(item) {
      const filtered = this.selectedPackages.filter((p) => p.id === item.id)
      if (filtered.length) {
        this.selectedPackages = this.selectedPackages.filter((p) => p.id !== item.id)
      } else {
        this.selectedPackages.push(item)
      }
    },
    printSelectedPackages() {
      const selectedPackages = this.selectedPackages
      if (selectedPackages.length === 0) {
        return this.$bvToast.toast('No hay envíos seleccionados', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
      this.printLabelsByIds(selectedPackages.map(p => p.id), selectedPackages)
    },
    async bulkPrintByDate() {
      if (!this.filters.from || !this.filters.to) {
        return this.$bvToast.toast('Debe seleccionar un rango de fechas', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }

      await this.listDelivery({ params: { ...this.filters, size: 300 } })
      this.selectedPackages = [...this.deliveries]
      const selectedPackages = this.selectedPackages
      if (selectedPackages.length === 0) {
        return this.$bvToast.toast('No hay envíos para la fecha seleccionada', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
      await this.printLabelsByIds(selectedPackages.map(p => p.id), selectedPackages)
      this.fetchData()
    },
    printPackageLabel(item) {
      this.printLabelsByIds([item.id], [item])
    },
    /**
     * spec 003: misma firma/patrón que ListStoreDelivery.vue#printLabelsByIds.
     * Consulta el endpoint /delivery/labels-by-ids y, si la respuesta viene vacía
     * o falla, hace fallback al contexto armado en frontend.
     */
    async printLabelsByIds(ids, fallbackItems) {
      try {
        const response = await this.getLabelsByIds({ ids })
        if (response && response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
          this.$refs.shippingLabels.print(response.data)
          return
        }
        throw new Error('Respuesta vacía')
      } catch (err) {
        const contexts = (fallbackItems || []).map(p => this.getLabelContext(p))
        if (contexts.length === 0) {
          this.$bvToast.toast('No se pudo obtener la información de las etiquetas', {
            title: 'Error',
            variant: 'danger'
          })
          return
        }
        this.$refs.shippingLabels.print(contexts)
      }
    },
    getLabelContext(item) {
      return {
        id: item.id,
        customerName: item.customerName,
        customerPhone: item.customerPhone,
        customerAddress: item.address ? item.address.street : '',
        customerFullAddress: item.address ? `${item.address.street}, ${item.address.commune}` : '',
        commentary: item.commentary,
        commune: item.address ? item.address.commune : '',
        storeName: item.store ? item.store.name : '',
        storeAddressStreet: item.store ? item.store.address.street : '',
        storeAddressStreetNumber: item.store ? item.store.address.streetNumber : '',
        storeAddressApartment: item.store ? item.store.address.apartment : '',
        storeAddressCommune: item.store ? item.store.address.commune : '',
        contactAccountName: item.store ? item.store.contactAccountName : ''
      }
    },
    linkGen(pageNum) {
      return {
        path: '/envios/',
        query: { page: pageNum }
      }
    },
    handleResize() {
      this.ancho = window.innerWidth
    },
    onDoneDeliveryModal() {
      this.listDelivery()
      this.$refs.createDeliveryFormModal.hide()
      this.$refs.updateDeliveryFormModal.hide()
      this.$emit('done')
      this.fetchData()
    },
    async onDeleteDelivery(delivery) {
      const ok = await this.$bvModal.msgBoxConfirm(`¿Está seguro que desea eleminar el envío ${delivery.id} de la tienda${delivery.store ? ' ' + delivery.store.name : ''}?`)
      if (!ok) return

      const response = await this.deleteDelivery({ id: delivery.id })
      if (response.status === 200) {
        this.makeSuccessToast('El envío se eliminó correctamente')
        this.$emit('done')
      } else if (response.status >= 400 && response.status < 500) {
        this.makeDangerToast(response.data.message || 'Error al eliminar el envío')
      }
      await this.fetchData()
    },
    openEditModal(delivery) {
      this.selectedDelivery = delivery
      this.$refs.updateDeliveryFormModal.show()
    },
    openAdvancedEditModal(delivery) {
      this.selectedDelivery = delivery
      this.$refs.advancedEditDeliveryFormModal.show()
    },
    onDoneAdvancedEditModal() {
      this.$refs.advancedEditDeliveryFormModal.hide()
      this.fetchData()
    },
    async fetchData() {
      this.isBusy = true
      this.lastIdRequestDeliveries = Math.random()
      const lastIdRequestDeliveries = this.lastIdRequestDeliveries
      const response = await this.listDelivery({ params: { ...this.filters } })
      if (lastIdRequestDeliveries !== this.lastIdRequestDeliveries) return
      this.countPartnerErrorDeliveries({ params: { ...this.filters } })
      this.getCountStates({ params: { ...this.filters } })
      if (response) {
        this.totalPages = response.data.totalPages
      }
      this.selectedAllIds = false
      this.toggleSelectAll(false)
      this.isBusy = false
    },
    handleFilterErrors(apply) {
      if (apply) {
        this.filterOptions.withPartnerSyncError = true

      } else {
        this.filterOptions.withPartnerSyncError = null
      }
      this.$nextTick(() => {
        this.fetchData()
      })
    },
    openConfirmScanModal(delivery) {
      if (this.scanChangeDebounce) return
      this.scanChangeDebounce = true
      setTimeout(() => { this.scanChangeDebounce = false }, 500)
      this.selectedDeliveryForScan = delivery
      this.showConfirmScanModal = true
    },
    pickupBadgeId(item) {
      return `pickup-badge-${item.id}`
    },
    hasPickupScanInfo(item) {
      return Boolean(item.pickedUpAtStoreAt || item.pickedUpAtStoreBy || item.pickedUpAtStoreMode)
    },
    formatPickupDate(value) {
      if (!value) return '—'
      const m = this.$moment && this.$moment(value)
      return m && m.isValid() ? m.format('DD-MM-YYYY HH:mm') : String(value)
    },
    formatPickupUser(item) {
      if (!item) return '—'
      const by = item.pickedUpBy
      if (by) {
        const full = [by.name, by.lastName].filter(Boolean).join(' ').trim()
        if (full) return full
      }
      // Fallback al id crudo cuando el include no resolvió (envíos viejos,
      // user eliminado, o respuesta cacheada anterior al include).
      if (item.pickedUpAtStoreBy) return `#${item.pickedUpAtStoreBy}`
      return '—'
    },
    formatPickupMode(value) {
      if (!value) return '—'
      const map = { qr: 'QR', manual: 'Manual' }
      return map[value] || value
    },
    async onConfirmScanChange(delivery) {
      if (!delivery || !delivery.id) {
        this.showConfirmScanModal = false
        return
      }
      this.showConfirmScanModal = false
      try {
        const response = await this.scanDelivery({ id: delivery.id, mode: 'manual' })
        if (response && response.status === 200) {
          this.makeSuccessToast(`Envío ${delivery.id} recepcionado`)
          await this.fetchData()
        } else if (response && response.status === 400) {
          const message = response.data && response.data.message
            ? response.data.message
            : 'No se pudo cambiar el estado'
          this.makeDangerToast(message)
        } else if (response && response.status === 403) {
          this.makeDangerToast('No tiene permisos sobre este envío')
        } else if (response && response.status === 404) {
          this.makeDangerToast('Envío no encontrado')
        } else {
          this.makeDangerToast('Error al cambiar el estado')
        }
      } catch (err) {
        const message = err && err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : 'Error de red al cambiar el estado'
        this.makeDangerToast(message)
      }
    }
  },
  computed: {
    ...mapGetters(['deliveries', 'drivers', 'stores', 'user', 'partnerErrorCount']),
    canChangeScan() {
      console.log(this.user)
      return this.user && (this.user.role === 'admin')
    },
    deliveryData() {
      let items = []
      if (this.deliveries) {
        items = this.deliveries.reduce((acum, delivery) => acum.concat({
          id: delivery.id,
          storeName: delivery.store ? delivery.store.name : 'No encontrado',
          store: delivery.store,
          customerName: delivery.customerName,
          address: delivery.address.street,
          commune: delivery.address.commune,
          date: this.$moment(delivery.date.substring(0, 10)).format('DD-MM-YYYY'),
          customerPhone: delivery.customerPhone,
          actions: delivery,
          _rowVariant: delivery.hide ? 'primary' : undefined,
          state: delivery.state ? delivery.state.replace(/^./, delivery.state[0].toUpperCase()) : 'Por entregar',
          driverName: delivery.driver ? `${delivery.driver.name} ${delivery.driver.lastName}` : 'No encontrado',
          lastSendSMS: delivery.lastSendSMS,
          lastSendSMSErrorMessage: delivery.lastSendSMSErrorMessage,
          partnerCode: delivery.partnerCode,
          pickup: delivery.pickedUpAtStore === true,
          pickedUpAtStoreAt: delivery.pickedUpAtStoreAt,
          pickedUpAtStoreBy: delivery.pickedUpAtStoreBy,
          pickedUpBy: delivery.pickedUpBy,
          pickedUpAtStoreMode: delivery.pickedUpAtStoreMode
        }), [])
      }
      return items
    },
    allDeliveryIds() { return this.deliveries.map(delivery => delivery.id) },
    filters() {
      const filter = {}
      for (const key in this.filterOptions) {
        if (this.filterOptions[key] !== null && this.filterOptions[key] !== '') {
          filter[key] = this.filterOptions[key]
        }
      }
      return filter
    },
    driverOptions() {
      return this.drivers.reduce((acum, driver) => acum.concat({
        label: `${driver.name} ${driver.lastName}`,
        value: driver.id
      }), [{ label: 'Repartidor', value: null }])
    },
    storeOptions() {
      const stores = []
      stores.push({ value: null, label: 'Tienda' })
      this.stores.forEach(store => {
        stores.push({ value: store.id, label: store.name })
      })
      return stores
    }
  },
  created() {
    this.listUser()
    window.addEventListener('resize', this.handleResize)
    this.fetchData()
    this.listStore()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    selectedIds() {
      this.selectedAllIds = this.selectedIds.length === this.allDeliveryIds.length
    },
    currentPage(valor) {
      this.toggleSelectAll(false)
      this.filterOptions.page = valor - 1
      this.fetchData()
    },
    'filterOptions.search': {
      handler(value) {
        if (value.length !== 1) {
          // console.log('Valor de búsqueda', value)
          if (this.fetchDebounce) {
            clearTimeout(this.fetchDebounce)
          }
          this.fetchDebounce = setTimeout(() => {
            this.fetchData()
          }, 800)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.botones-accion {
  display: inline-flex;
}

.boton-editar-avanzado {
  color: #fff;
  background-color: #6f42c1;
  border-color: #6f42c1;
}
.boton-editar-avanzado:hover {
  color: #fff;
  background-color: #5e37a6;
  border-color: #5a32a2;
}

.pickup-cell {
  display: flex;
  justify-content: center;
}

.pickup-badge {
  font-size: 0.8rem;
  padding: 0.4em 0.65em;
}

.pickup-badge--clickable {
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.pickup-badge--clickable:hover {
  opacity: 0.85;
}

.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #869099;
  outline: 0;
  box-shadow: 0 0 0 0.2rem #ced4da;
}

.pickup-tooltip {
  font-size: 0.85rem;
  line-height: 1.3;
  text-align: left;
}

.pickup-tooltip__row {
  display: flex;
  gap: 0.4rem;
  white-space: nowrap;
}

.pickup-tooltip__label {
  font-weight: 600;
  color: #ffffff;
}

.pickup-tooltip__value {
  color: #ffffff;
}
</style>
